export const EMPLOYEE = "employee";

export const ACTIVE = "active";
export const PENDING = "pending";
export const SUSPEND = "suspend";
